import { FC } from "react";

import { CanonicalTagsConfig } from "@simplyk/common";

export const CanonicalTags: FC<CanonicalTagsConfig> = ({ url, default: defaultUrl, alternate }) => {
  return (
    <>
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="x-default" href={defaultUrl ?? url} />
      {alternate &&
        Object.entries(alternate).map(([isoLocale, url]) => (
          <link key={isoLocale} rel="alternate" hrefLang={isoLocale} href={url} />
        ))}
    </>
  );
};
